import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="w-full py-6 bg-[#2C2E2D] border-t border-[#404140] mt-auto">
      <div className="container mx-auto px-4">
        <div className="flex flex-col md:flex-row justify-between items-center">
          <div className="mb-4 md:mb-0">
            <p className="text-[#818881] text-sm">
              © {new Date().getFullYear()} JobPin. All rights reserved.
            </p>
          </div>
          
          <div className="flex space-x-6">
            <Link to="/terms" className="text-[#D9D9D9] hover:text-[#CCF751] text-sm transition-colors">
              Terms of Service
            </Link>
            <Link to="/privacy" className="text-[#D9D9D9] hover:text-[#CCF751] text-sm transition-colors">
              Privacy Policy
            </Link>
            <a 
              href="mailto:support@jobpin.example.com" 
              className="text-[#D9D9D9] hover:text-[#CCF751] text-sm transition-colors"
              rel="noopener noreferrer"
            >
              Contact
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 